import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`What are containers?`}</h2>
    <p>{`Containers provide a method to encapsulate code, binaries, libraries, and runtimes. They act as a form of virtualization for an operating system. Containers are run on container orchestrators that provide the scheduling and high availability benefits. The most commonly used containers and container orchestrators are built on open source software, more on this below.`}</p>
    <h2>{`Why is this important for hybrid cloud developers?`}</h2>
    <p>{`Containers are one of the main drivers of modern software development and designing applications for clouds in general. However, containers become more important in a hybrid cloud or multicloud setting where consistency and repeatability are key.`}</p>
    <h2>{`Solution sketch`}</h2>
    <p>{`TBD`}</p>
    <h2>{`Limitations`}</h2>
    <p>{`TBD`}</p>
    <h2>{`Key open source projects`}</h2>
    <h3>{`Container engines and runtimes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`GitHub repo`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Get Started guide`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://podman.io/"
            }}>{`Podman`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/containers/podman"
            }}>{`GitHub Repo`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://podman.io/getting-started/"
            }}>{`Getting Started`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://containerd.io/"
            }}>{`containerd`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/containerd/containerd"
            }}>{`GitHub Repo`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://containerd.io/docs/getting-started/"
            }}>{`Getting Started`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://docs.docker.com/"
            }}>{`Docker`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/docker/engine"
            }}>{`GitHub Repo`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://docs.docker.com/get-started/"
            }}>{`Getting Started`}</a></td>
        </tr>
      </tbody>
    </table>
    <h3>{`Container orchestrators`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`GitHub repo`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Get Started guide`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://kubernetes.io"
            }}>{`Kubernetes`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/kubernetes/kubernetes"
            }}>{`GitHub Repo`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://kubernetes.io/docs/tutorials/kubernetes-basics/"
            }}>{`Get Started`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://docs.docker.com/engine/swarm/"
            }}>{`Docker Swarm`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/docker/swarmkit"
            }}>{`GitHub repo`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://containerd.io/docs/getting-started/"
            }}>{`https://containerd.io/docs/getting-started/`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "http://mesos.apache.org"
            }}>{`Meso`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/apache/mesos"
            }}>{`GitHub repo`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://docs.docker.com/engine/swarm/swarm-tutorial/"
            }}>{`Getting Started`}</a></td>
        </tr>
      </tbody>
    </table>
    <h3>{`Container registry`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`GitHub repo`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Get Started guide`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://www.projectquay.io/"
            }}>{`Quay`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/quay/quay"
            }}>{`GitHub repo`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://docs.quay.io/solution/getting-started.html"
            }}>{`Getting Started`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://goharbor.io/"
            }}>{`Harbor`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/goharbor/harbor"
            }}>{`GitHub repo`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://goharbor.io/docs/2.3.0/install-config"
            }}>{`Getting Started`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <h2>{`Cloud comparision`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}>{`IBM Cloud`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`GCP`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`AWS`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Azure`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Kubernetes service`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://cloud.ibm.com/kubernetes/catalog/create"
            }}>{`IKS`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://cloud.google.com/kubernetes-engine"
            }}>{`GKE`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://aws.amazon.com/eks/"
            }}>{`EKS`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://azure.microsoft.com/en-us/services/kubernetes-service/"
            }}>{`AKS`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Supported versions`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.18 - 1.21`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`TBD`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`TBD`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`TBD`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Container runtime`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`containerd`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Docker, containerd`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Docker, containerd`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Docker, containerd`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Container registry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`based on Quay`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`TBD`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`TBD`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`TBD`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Additional resources`}</h2>
    <h3>{`Courses`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.cncf.io/certification/training"
        }}>{`CNCF: Certification and Training`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://cognitiveclass.ai/courses/kubernetes-course"
        }}>{`CognitiveClass.ai: Introduction to Containers, Kubernetes, and OpenShift`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://training.linuxfoundation.org/full-catalog/?_sft_topic_area=cloud-containers"
        }}>{`LinuxFoundation: Certification and Training`}</a></li>
    </ul>
    <h3>{`Blogs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/cloud/learn/kubernetes"
        }}>{`What is Kubernetes? | IBM Cloud Learn Hub`}</a></li>
    </ul>
    <h3>{`Videos`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://youtu.be/zsE9cU6yd4Y"
        }}>{`Getting started with containers and Kubernetes`}</a></li>
    </ul>
    <h3>{`Tutorials`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kubernetes.io/docs/tutorials/"
        }}>{`Tutorials | Kubernetes.io`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      